'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { ShellLogo } from './ShellLogo';
import { SidebarContents } from './SidebarContents';
import { SHELL_FOCUS } from './SidebarNav';

export function AppDrawer({
  open,
  onOpenChange,
  desktop = false,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  desktop?: boolean;
}) {
  const { t } = useTranslation();
  const pathname = usePathname();
  const query = useSearchParams().toString();
  useEffect(() => {
    onOpenChange(false);
  }, [pathname, query, onOpenChange]);
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="left"
        close={false}
        aria-label={t('navigation.pages')}
        aria-describedby={undefined}
        style={{ maxWidth: desktop ? 256 : 360 }}
        className={`fd-header h-dvh gap-0 p-0 ${desktop ? 'w-64' : 'w-[88vw]'}`}
      >
        <SidebarContents
          mobile={!desktop}
          onNavigate={() => onOpenChange(false)}
          header={
            <div className="flex min-h-16 items-center justify-between gap-1 border-b border-[var(--fd-line)] px-3">
              <ShellLogo onNavigate={() => onOpenChange(false)} />
              <button
                type="button"
                aria-label={t('navigation.closeMenu')}
                className={`flex size-11 shrink-0 items-center justify-center rounded-md hover:bg-[var(--fd-bg)] ${SHELL_FOCUS}`}
                onClick={() => onOpenChange(false)}
              >
                <X className="size-5" aria-hidden />
              </button>
            </div>
          }
        />
      </SheetContent>
    </Sheet>
  );
}
